import { render } from "./goaltype-model.vue?vue&type=template&id=49b3b5c0"
import script from "./goaltype-model.vue?vue&type=script&lang=js"
export * from "./goaltype-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__